import { Injectable } from '@angular/core';
import { catchAndGetFromFailureRxOp } from '@geekbears/gb-ngrx-stack-base';
import { Actions, createEffect, EffectsModule, ofType } from '@ngrx/effects';
import { map, mergeMap } from 'rxjs';
import { MembershipServices } from '../../domain/services/membership.service';
import { MembershipActions } from './membership.actions';

@Injectable()
export class MembershipEffects {
  constructor(
    private actions$: Actions,
    private membershipService: MembershipServices
  ) {}

  allMembers$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(MembershipActions.getAllPlans),
      mergeMap((action) => {
        const { type, ...params } = action;
        return this.membershipService
          .getAllMembership({
            filter: {
              archived: false,
              source: 'stripe',
            },
          })
          .pipe(
            map((membership) =>
              MembershipActions.getAllPlansSuccess({ membership })
            ),
            catchAndGetFromFailureRxOp((failure) =>
              MembershipActions.getAllPlansFailure({ failure })
            )
          );
      })
    );
  });

  allCards$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(MembershipActions.getAllCards),
      mergeMap((action) => {
        return this.membershipService.getAllCards(action.userId).pipe(
          map((cards) => MembershipActions.getAllCardsSuccess({ cards })),
          catchAndGetFromFailureRxOp((failure) =>
            MembershipActions.getAllCardsFailure({ failure })
          )
        );
      })
    );
  });

  deleteCard$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(MembershipActions.deleteCard),
      mergeMap((action) => {
        return this.membershipService
          .deleteCard(action.userId, action.paymentMethodId)
          .pipe(
            map((response) =>
              MembershipActions.deleteCardSuccess({ response })
            ),
            catchAndGetFromFailureRxOp((failure) =>
              MembershipActions.deleteCardFailure({ failure })
            )
          );
      })
    );
  });

  subscribeToPlan = createEffect(() => {
    return this.actions$.pipe(
      ofType(MembershipActions.subscribeToPlan),
      mergeMap((action) => {
        return this.membershipService
          .subscribeToPlan(action.subscriptionData)
          .pipe(
            map((response) =>
              MembershipActions.subscribeToPlanSuccess({ response })
            ),
            catchAndGetFromFailureRxOp((failure) =>
              MembershipActions.subscribeToPlanFailure({ failure })
            )
          );
      })
    );
  });
  updateSubscription$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(MembershipActions.updateMembership),
      mergeMap((action) => {
        return this.membershipService
          .updatePlanSubscription(action._subscription, action.data)
          .pipe(
            map((response) =>
              MembershipActions.updateMembershipSuccess({ response })
            ),
            catchAndGetFromFailureRxOp((failure) =>
              MembershipActions.updateMembershipFailure({ failure })
            )
          );
      })
    );
  });
  cancelMembership$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(MembershipActions.cancelMembership),
      mergeMap((action) => {
        return this.membershipService
          .cancelMembership(action._user, action._subscription)
          .pipe(
            map((response) =>
              MembershipActions.cancelMembershipSuccess({ response })
            ),
            catchAndGetFromFailureRxOp((failure) =>
              MembershipActions.cancelMembershipFailure({ failure })
            )
          );
      })
    );
  });

  addCard$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(MembershipActions.addCard),
      mergeMap((action) => {
        return this.membershipService.addCard(action.userId, action.token).pipe(
          map((response) => MembershipActions.addCardSuccess({ response })),
          catchAndGetFromFailureRxOp((failure) =>
            MembershipActions.addCardFailure({ failure })
          )
        );
      })
    );
  });
}
export const MembershipEffectsModule = EffectsModule.forFeature([
  MembershipEffects,
]);
